// toggle_checkbox_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    console.log("Stimulus: togglecontroller connected!")
  }
  toggle(event) {
    event.preventDefault()

    const table = this.element.closest("table")
    const checkboxes = table.querySelectorAll("input[type='checkbox']")
    const allChecked = Array.from(checkboxes).every(cb => cb.checked)

    checkboxes.forEach(cb => cb.checked = !allChecked)
  }
}
